import { NgbDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import { BaseEntity } from "yt-ng-framework";

export class PojedinacnaEvidencijaPdvView extends BaseEntity{
    constructor(){
        super();
    }

    BrojPojedinacneEvidencijePdv: string;
    Period: string;
    StatusGenericName: string;
    StatusColor: string;
    StatusTooltip: string;
    BrojDokumenta: string;
    TipDokumenta: string;
    UkupanIznosNaknade: number;
    ObracunatiPdv: number;
    KomitentId: number;
    KomitentPib: string;
    KomitentJbkjs: string;
    KomitentNaziv: string;
    OsvezivogStatusa:boolean;
    VremenskiOpseg: string = null;
    ProvajderID: number = null;
    EdokumentID: string = null;
    Datum: NgbDate = null; 
    DatumObracuna: NgbDate = null;
    Godina : number;
    PeriodId : number;
    PoreskiPeriodId : number;
    
    Deserialize(input: any){
        this.ID =  input.ID;
        this.BrojPojedinacneEvidencijePdv = input.BrojPojedinacneEvidencijePdv;
        this.Period = input.Period;
        this.StatusGenericName = input.StatusGenericName;
        this.StatusColor = input.StatusColor;
        this.StatusTooltip = input. StatusTooltip;
        this.BrojDokumenta = input.BrojDokumenta;
        this.TipDokumenta = input.TipDokumenta;
        this.UkupanIznosNaknade = input.UkupanIznosNaknade;
        this.ObracunatiPdv = input.ObracunatiPdv;
        this.KomitentId = input.KomitentId;
        this.KomitentPib = input.KomitentPib;
        this.KomitentJbkjs = input.KomitentJbkjs;
        this.KomitentNaziv = input.KomitentNaziv;
        this.OsvezivogStatusa = input.OsvezivogStatusa;
        this.VremenskiOpseg = input.VremenskiOpseg;
        this.ProvajderID = input.ProvajderID;
        this.EdokumentID = input.EdokumentID;
        this.Datum = input.Datum;
        this.DatumObracuna = input.DatumObracuna;
        this.Godina = input.Godina;
        this.PeriodId = input.PeriodId;
        this.PoreskiPeriodId = input.PoreskiPeriodId;
        return this;
    }

    Serialize(input: PojedinacnaEvidencijaPdvView) {
        return input;
    }
}